import { jsonldKeywords } from './JsonldStore';

export const updateJsonldKeywords = (value) => jsonldKeywords.update((oldValue) => value);
